import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
  'en-US': {
    "Continuar": "Continue",
    "Editar dados": "Edit data",
    "Desvincular": "Unbind this device",
    "Remover meus dados": "Delete my data",
    "Olá": "Hello",
    "Voltar": "Go back",
    "Atualizar e Entrar": "Update and login",
    "Salvar e Entrar": "Save and login",
    "Alerta": "Alert",
    "Os dados nesse portal serão removidos. Deseja continuar": "The data on this portal will be removed. Do you wish to proceed",
    "Sim": "Yes",
    "Não": "No",
    "Cadastre-se para navegar": "Logon to navigate",
    "Cadastrar": "Logon",
    "Mudar Idioma": "Change Language",
    "Login com Facebook": "Fill with Facebook",
    "Aceito os": "I accept the",
    "Termos de Serviço": "Terms and Conditions"
  },
  'pt-BR': {
    "Continuar": "Continuar",
    "Editar dados": "Editar dados",
    "Desvincular": "Desvincular dispositivo",
    "Remover meus dados": "Remover meus dados",
    "Olá": "Olá",
    "Voltar": "Voltar",
    "Atualizar e Entrar": "Atualizar e Entrar",
    "Salvar e Entrar": "Salvar e entrar",
    "Alerta": "Alerta",
    "Os dados nesse portal serão removidos. Deseja continuar": "Os dados nesse portal serão removidos. Deseja continuar",
    "Sim": "Yes",
    "Não": "No",
    "Cadastre-se para navegar": "Cadastre-se para navegar",
    "Cadastrar": "Cadastrar",
    "Mudar Idioma": "Mudar Idioma",
    "Login com Facebook": "Preencher com Facebook",
    "Aceito os": "Aceito os",
    "Termos de Serviço": "Termos de Serviço"
  }
};

export default new VueI18n({
  locale: 'pt-BR', // set locale    
  fallbackLocale: 'en-US', // set fallback locale    
  messages, // set locale messages
});



// WEBPACK FOOTER //
// ./src/plugins/i18n.js